import React from 'react'
import Navbar from '../../LandingPage/Navbar/Navbar'
import Footer2 from '../../Footer2/Footer2'
import ClinicalSummaries from '../../NewsRoom2/ClinicalSummaries/ClinicalSummaries';
import LatestDrops from '../../NewsRoom2/LatestDrops/LatestDrops';
import FeaturedStories from '../../NewsRoom2/FeaturedStories/FeaturedStories';
import FromVision from '../../NewsRoom2/FromVision/FromVision';
import TopBar from '../../EdofSectionNew2/TopBar/TopBar';
const NewsRoomPage2 = () => {
  return (
    <div>
      <TopBar/>
      <Navbar />
      <ClinicalSummaries />
      <LatestDrops/>
      <FeaturedStories/>
      <FromVision/>
      <Footer2 />

    </div>
  )
}

export default NewsRoomPage2
